module.exports = __webpack_public_path__ + "static/media/1POLICY3.f0150e3d.jpg";